module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/downArrow.d3d1ab80.svg";